import * as configureSolarApi from '../store/configureSolarApi';

const pvfinalbillReducer = (state = {
    PvFinalbillUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_PvFinalBillClass_pvfinalbillReducer":
            return { ...state, PvFinalbillUI: action.value, isLoaded: true };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default pvfinalbillReducer;
